import React, { FC, ReactNode, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from 'styled-components';

import { ServiceProvider } from './contexts/ServiceContext';
import { RouterProvider } from './contexts/RouterContext';
import { CartProvider } from './contexts/CartContext';
import { PaymentProvider } from './contexts/PaymentContext';

import { GlobalStyle } from './styles/GlobalStyles';
import { PatientProvider } from './contexts/PatientContext';
import { ScheduleProvider } from './contexts/ScheduleContext';
import theme from './styles/theme';
import { ModuleProvider } from './contexts/ModuleContext';
import { PlatformProvider } from './contexts/PlatformContext';
import { SpecialistProvider } from './contexts/SpecialistContext';
import { SDKContext } from './contexts/SDKContext';

type TemplateProvidersProps = {
  children: ReactNode;
  onCloseSDK?: () => void;
};

export const TemplateProviders: FC<TemplateProvidersProps> = ({ onCloseSDK, children }) => {
  function setViewportHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  useEffect(() => {
    setViewportHeight();
    window.addEventListener('resize', () => {
      setViewportHeight();
    });
  }, []);

  const SDKContextValue = {
    onClose: () => onCloseSDK?.()
  };
  return (
    <ThemeProvider theme={theme}>
      <SDKContext.Provider value={SDKContextValue}>
        <RouterProvider>
          <GlobalStyle />
          <ServiceProvider>
            <ScheduleProvider>
              <CartProvider>
                <PaymentProvider>
                  <PatientProvider>
                    <SpecialistProvider>
                      <ModuleProvider>
                        <PlatformProvider>
                          <Helmet>
                            <link rel="preconnect" href="https://fonts.googleapis.com" />
                            <link rel="preconnect" href="https://fonts.gstatic.com" />
                            <link
                              href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap"
                              rel="stylesheet"
                            />
                          </Helmet>
                          {children}
                          <ToastContainer theme={'colored'} />
                        </PlatformProvider>
                      </ModuleProvider>
                    </SpecialistProvider>
                  </PatientProvider>
                </PaymentProvider>
              </CartProvider>
            </ScheduleProvider>
          </ServiceProvider>
        </RouterProvider>
      </SDKContext.Provider>
    </ThemeProvider>
  );
};
